import React from 'react';

const ErrorIcon = (props: { style: any }) => {
  const { style } = props;
  return (
    <svg
      style={style}
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1zm1 8.2a1 1 0 1 0-2 0v.8a1 1 0 1 0 2 0v-.8z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ErrorIcon;
